export const CustomerSearchActionTypes = {
    SEARCH: 'SEARCH',
    VALUE_UPDATE: 'VALUE_UPDATE',
    SET_SEARCH_VALUE: 'SET_SEARCH_VALUE',
    SET_SEARCH_BY_VALUE: 'SET_SEARCH_BY_VALUE',
    SET_STATUS: 'SET_STATUS',
    RESET: 'RESET',
  };

  export const EMPLOYEE_TYPE_VALUE = [
    "CH",
    "ZH",
    "BU Head",
    "RH",
    "TL",
    "DSA",
    "FSE",
    "Seller / Seller Boy",
    "Variable Pay Executive",
    "Seller Staff",
    "Variable Pay Agent",
    "Seller",
    "Team Lead",
    "Region Head",
    "Category Head",
    "Cluster Head",
    "Zonal Head",
    "Permanent",
  ];

  export const ProviderTypeOptions = [
    { label: "LogisticProvider", value: "LogisticProvider" },
    { label: "LoanServiceProvider", value: "LoanServiceProvider" },
    { label: "Retailer", value: "Retailer" },
    { label: "KiranaStore", value: "KiranaStore" },
    { label: "Lender", value: "Lender" },
    { label: "Assurance", value: "Assurance" },
    { label: "Exporter", value: "Exporter" },
    { label: "Importer", value: "Importer" },
    { label: "Trader", value: "Trader" },
    { label: "Accounting", value: "Accounting" },
    { label: "Commerce", value: "Commerce" },
    { label: "Fintech", value: "Fintech" },
    { label: "Miller", value: "Miller" },
    { label: "Marketplace", value: "Marketplace" },
  ];

  export const ToolTypeOptions = [
    { label: "Marketplace", value: "Marketplace" },
    { label: "Logistics", value: "Logistics" },
    { label: "Assurance", value: "Assurance" },
    { label: "Payment", value: "Payment" },
    { label: "Fintech", value: "Fintech" },
    { label: "Invoice", value: "Invoice" },
    { label: "BNPL", value: "BNPL" },
    { label: "INPUT_RETAILER", value: "INPUT_RETAILER" },
    { label: "FARMING", value: "FARMING" },
    { label: "AgriAdvisory", value: "AgriAdvisory" },
  ];

  export const EditProviderFeilds = [
    { label: "Provider ID", id: "id", type: "text", isEdit: false, required: true },
    { label: "Provider Name", id: "name", type: "text", isEdit: true, required: true },
    { label: "Provider Type", id: "type", type: "select", isEdit: true, required: true },
    { label: "Description", id: "description", type: "textarea", isEdit: true, required: true },
    { label: "External ID", id: "externalId", type: "text", isEdit: true, required: false },
    { label: "Agri Network ID", id: "agriNetworkId", type: "text", isEdit: true, required: false },
    { label: "GSTN ID", id: "gstnId", type: "text", isEdit: true, required: false },
  ];

  export const EditToolFeids = [
    { label: "Provider ID", id: "providerId", type: "text", isEdit: false, required: true },
    { label: "Tool ID", id: "id", type: "text", isEdit: false, required: true },
    { label: "Tool Name", id: "name", type: "text", isEdit: true, required: true },
    { label: "Tool Type", id: "type", type: "select", isEdit: true, required: true },
    { label: "Description", id: "description", type: "textarea", isEdit: true, required: true },
    { label: "External ID", id: "externalId", type: "text", isEdit: true, required: false },
  ]  

  export const InitiatorTypeOptions = [
  { label: "USER", value: "USER" },
  { label: "SYSTEM", value: "SYSTEM" },
  ];

export const OperationOptions = [
  { label: "fetch", value: "fetch" },
  { label: "validate", value: "validate" },
  { label: "ocr", value: "ocr" },
  { label: "onupdate", value: "onupdate" },
  { label: "upload", value: "upload" },
  { label: "processdigitalassets", value: "processdigitalassets" },
  { label: "appendassets", value: "appendassets" },
  { label: "simulate", value: "simulate" },
  { label: "simulatecreation", value: "simulatecreation" },
];

export const ModeOptions = [
  { label: "PRE_PROCESS", value: "PRE_PROCESS" },
  { label: "PROCESS", value: "PROCESS" },
  { label: "POST_PROCESS", value: "POST_PROCESS" },
];

export const InputTypeOptions = [
  { label: "FILE", value: "FILE" },
  { label: "TEXT", value: "TEXT" },
];

export const ProviderOptions = [
  { label: "karza", value: "karza" },
  { label: "equifax", value: "equifax" },
  { label: "digio", value: "digio" },
  { label: "crif", value: "crif" },
  { label: "scienaptic", value: "scienaptic" },
  { label: "scoreme", value: "scoreme" },
  { label: "perfios", value: "perfios" },
  { label: "ninjacart", value: "ninjacart" },
  { label: "finbox", value: "finbox" },
  { label: "knap", value: "knap" },
  { label: "cpv", value: "cpv" },
  { label: "shuftipro", value: "shuftipro" },
  { label: "ckyc", value: "ckyc" },
  { label: "digilocker", value: "digilocker" },
  { label: "srm", value: "srm" },
  { label: "astute", value: "astute" },
  { label: "monnai", value: "monnai" },
  { label: "risk", value: "risk" },
  { label: "decentro", value: "decentro" },
  { label: "trillionloans", value: "trillionloans" },
];

export const EvaluationModeOptions = [
  { label: "CONTINUOUS", value: "CONTINUOUS" },
  { label: "LOGICAL_AND", value: "LOGICAL_AND" },
  { label: "LOGICAL_OR", value: "LOGICAL_OR" },
];

export const ExpressionTypeOptions = [
  { label: "CONDITIONAL", value: "CONDITIONAL" },
  { label: "EXPRESSION", value: "EXPRESSION" },
  { label: "TEXT_REPLACEMENT", value: "TEXT_REPLACEMENT" },
  { label: "MAPPING", value: "MAPPING" },
  { label: "VALIDATION", value: "VALIDATION" },
];

export const OnStatusOptions = [
  { label: "APPROVED", value: "APPROVED" },
  { label: "REJECTED", value: "REJECTED" },
  { label: "PENDING", value: "PENDING" },
];


  export const SEGMENT_PAGE_LIMIT = 10;

  export const searchQuery = (projectId, searchTerm = "") =>
    `projectId==${projectId}${searchTerm ? `;name==%${searchTerm}%` : ""}`;

  export const SEARCH_DEBOUNCE_TIME = 300;